import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import PeoplePrint from './components/PeoplePrint';
import CompanyInfoPrint from './components/CompanyInfoPrint';
import RecordsPrint from './components/RecordsPrint';
import FinancialInfoPrint from './components/FinancialInfoPrint';
import CompanyPrintHeader from './components/Header';
import CompanySummaryPrint from './components/CompanySummaryPrint';
import CompanyLinkPrint from './components/CompanyLinkPrint';
import InputDataPrint from './components/InputDataPrint';

import './styles.less';

const CompanyPrint = forwardRef(
  (
    {
      transactionId,
      createdAt,
      riskLevel,
      executionStatus,
      companyInfo,
      summary,
      financial,
      people,
      companyLinks,
      records,
      inputData,
      itemsToExport,
      setLoading,
    },
    ref
  ) => {
    return (
      <div ref={ref} id="company-to-print">
        <CompanyPrintHeader
          companyName={summary.title}
          identifier={summary.identifier}
          riskLevel={riskLevel}
          executionStatus={executionStatus}
          createdAt={createdAt}
        />
        <CompanySummaryPrint summary={summary} itemsToExport={itemsToExport.summary} />
        <CompanyInfoPrint
          companyInfo={companyInfo}
          otherAddresses={summary.otherAddresses}
          itemsToExport={itemsToExport.companyInfo}
        />
        <FinancialInfoPrint
          financial={financial}
          itemsToExport={itemsToExport.financial}
        />
        <PeoplePrint peopleData={people} itemsToExport={itemsToExport.people} />
        <CompanyLinkPrint
          companyLinks={companyLinks}
          itemsToExport={itemsToExport.companyLinks}
        />
        <RecordsPrint
          transactionId={transactionId}
          companyName={summary.companyName}
          data={records}
          itemsToExport={itemsToExport.records}
          setLoading={setLoading}
        />
        <InputDataPrint data={inputData} itemsToExport={itemsToExport.inputData} />
      </div>
    );
  }
);

export default CompanyPrint;

CompanyPrint.propTypes = {
  transactionId: PropTypes.string.isRequired,
  riskLevel: PropTypes.number.isRequired,
  executionStatus: PropTypes.any.isRequired,
  companyInfo: PropTypes.any.isRequired,
  summary: PropTypes.any.isRequired,
  financial: PropTypes.any.isRequired,
  people: PropTypes.any.isRequired,
  companyLinks: PropTypes.any.isRequired,
  records: PropTypes.any.isRequired,
  inputData: PropTypes.any.isRequired,
  itemsToExport: PropTypes.any.isRequired,
  setLoading: PropTypes.func.isRequired,
};
